// LimitText Class
import { LimitText } from "../classes/LimitText";

const largeNewsCardsParagraph = document.querySelectorAll(".large-news p.card-text");
const smallNewsCardsParagraph = document.querySelectorAll(".small-news p.card-text");

largeNewsCardsParagraph.forEach( (paragraph) => {
    let limit = 300;
    let inputText = paragraph.innerHTML;
    if ( inputText.length > limit ) {
        let limit_Text_size = new LimitText(inputText, limit);
        paragraph.innerHTML = limit_Text_size.limitOutput;
    }
});


smallNewsCardsParagraph.forEach( (paragraph) => {
    let limit = 150;
    let inputText = paragraph.innerHTML;
    if ( inputText.length > limit ) {
        let limit_Text_size = new LimitText(inputText, limit);
        paragraph.innerHTML = limit_Text_size.limitOutput;
    }
});

const cardsParagraph1 = document.querySelectorAll("#professionals-slider p");
const cardsParagraph2 = document.querySelectorAll("#professionals-slider2 p");

cardsParagraph1.forEach( (paragraph) => {
    let limit = 150;
    let inputText = paragraph.innerHTML;
    if ( inputText.length > limit ) {
        let limit_Text_size = new LimitText(inputText, limit);
        paragraph.innerHTML = limit_Text_size.limitOutput;
    }
});

cardsParagraph2.forEach( (paragraph) => {
    let limit = 100;
    let inputText = paragraph.innerHTML;
    if ( inputText.length > limit ) {
        let limit_Text_size = new LimitText(inputText, limit);
        paragraph.innerHTML = limit_Text_size.limitOutput;
    }
});